import { useEffect, useRef } from 'preact/hooks';
import { type APIHistoryItem, isPending } from '../core';
import { formatDate, isToday, isYesterday } from '../app/format';
import { Spinner } from './components';
import { HistoryRow } from './home';
import { History } from './icons';
import { ui, useApp } from './state';

export function ActivityView() {
  const { s, model } = useApp();
  const end = useRef<HTMLDivElement>(null);
  const history = model.history;

  // Load older pages when the end of the list becomes visible.
  useEffect(() => {
    const el = end.current;
    if (!el || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((e) => {
      if (e.some((x) => x.isIntersecting)) void model.loadMoreHistory();
    });
    io.observe(el);
    return () => io.disconnect();
  }, [history.length]);

  const groups: { day: string; items: APIHistoryItem[] }[] = [];
  for (const it of history) {
    let day: string;
    if (isPending(it) || it.time === 0) day = s.pending;
    else {
      const d = new Date(it.time * 1000);
      day = isToday(d) ? s.today : isYesterday(d) ? s.yesterday : formatDate(d, false);
    }
    const last = groups[groups.length - 1];
    if (last && last.day === day) last.items.push(it);
    else groups.push({ day, items: [it] });
  }

  return (
    <div class="tab-page">
      <h1 class="large-title page-title">{s.activity}</h1>
      {!model.snapshot ? <div class="center pad"><Spinner /></div>
        : history.length === 0 ? (
          <div class="empty">
            <History size={40} />
            <p class="dim">{s.noTransactions}</p>
          </div>
        ) : groups.map((g) => (
          <section class="group">
            <div class="group-title">{g.day}</div>
            <div class="group-body">
              {g.items.map((it, i) => (
                <>
                  <HistoryRow item={it} onClick={() => ui.open({ type: 'tx', item: it })} />
                  {i < g.items.length - 1 && <div class="divider inset" />}
                </>
              ))}
            </div>
          </section>
        ))}
      <div ref={end} class="list-end">{model.isLoadingHistory && <Spinner />}</div>
    </div>
  );
}
